import { Pipe, PipeTransform } from '@angular/core';
import { TourOptions } from '../types/leasing-fallbacks';
import { getTourTypeOptionName } from '../utils/leasing.utils';
import { TourTypesOptions } from '../core/enums/leasing.enum';

@Pipe({
  name: 'tourOptionHighestPriority',
})
export class TourOptionHighestPriorityPipe implements PipeTransform {
  transform(tourOptions: TourOptions): string[] {
    if (!tourOptions) {
      return [];
    }

    // Filter and map options with priority 1 and allowed status
    return Object.entries(tourOptions)
      .filter(([_, option]) => option?.priority === 1 && option?.allowed)
      .map(([key]) => getTourTypeOptionName(key as TourTypesOptions));
  }
}
